import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69f93068"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 2 }

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'custom-button',
  props: {
  text: {
    type: String,
    required: true
  },
  href: {
    type: String,
    required: true
  },
  refType: {
    type: String,
    required: true
  },
  size: {
    type: String,
    required: false
  }
},
  emits: ['click'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const isInternalRoute = computed(() => props.refType === 'internalRoute')
const isExternalRoute = computed(() => props.refType === 'externalRoute')
const isGenericButton = computed(() => props.refType === 'genericButton')
const buttonClass = computed(() => props.size === 'small' ? 'custom-button-small' : 'custom-button')

const handleClick = (event: any) => {
  emit('click')
  event.stopPropagation()
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (isInternalRoute.value)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: __props.href,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClick($event)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            class: _normalizeClass(buttonClass.value),
            color: "btnPrimary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.text), 1)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }, 8, ["to"]))
    : (isGenericButton.value)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          rel: "noopener noreferrer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClick($event)))
        }, [
          _createVNode(_component_v_btn, {
            class: _normalizeClass(buttonClass.value),
            color: "btnPrimary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.text), 1)
            ]),
            _: 1
          }, 8, ["class"])
        ]))
      : (isExternalRoute.value)
        ? (_openBlock(), _createElementBlock("a", _hoisted_1, [
            _createVNode(_component_v_btn, {
              class: _normalizeClass(buttonClass.value),
              color: "btnPrimary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.text), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ]))
        : _createCommentVNode("", true)
}
}

})